import { styled, Typography } from "@l2r-front/l2r-ui"

export const RoadworkTagsListContainer = styled("div")(({ theme }) => ({
    alignItems: "start",
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
}))

export const Title = styled(Typography)(() => ({
    whiteSpace: "nowrap",
}))